module.exports = __webpack_public_path__ + "static/media/rhe84mGrid.acf1e329.jpg";